export default __webpack_public_path__ + "static/media/sap.87445bdd.png";